import { Component, Input, OnInit, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { NgbDateStruct, NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MeetingagendacomplianceComponent } from '../meetingagendacompliance/meetingagendacompliance.component';
import { MeetingMasterService } from '../../../services/meetingMaster.service';
import { ViewSDKClient } from '../../../services/ViewSDKClient.service';
import { environment } from '../../../../environments/environment';
import { data } from 'jquery';
import * as _ from 'lodash';
import { take, last } from 'rxjs/operators';
import { Subscription } from 'rxjs';

declare var $: any;
declare var jQuery: any;

import { MeetingagendaComponent } from '../meetingagenda/meetingagenda.component';

@Component({
  providers: [MeetingagendaComponent],
  selector: 'app-agendadetail',
  templateUrl: './agendadetail.component.html',
  styleUrls: ['./agendadetail.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AgendadetailComponent {

  @Input('agendaObject') agendaObject: any;
  @Input('meetingObject') meetingObject: any;
  @Input('clickedAgenda') clickedAgenda: any;
  @Input('currentAgenda') currentAgenda: any;
  @Output() emitFileURL = new EventEmitter();


  urlSafe: SafeResourceUrl;
  agendaCompliances: any;
  isAgendaObjectEmpty: boolean;
  modalRef: NgbModalRef;
  agendaPdfIsAvailable: any;
  agendaUplaodedPdfID: any;
  agendaGenerationTitle: any;
  agendaGenerationNumber: any;
  agendaGenerationID: any;
  AgendaFile: any;
  count: number = null;
  newurl: any;
  FinalUrl: any;
  AttachMent: any;
  AgendaNumber: any;
  currentAgendaOnDisplay:number; // starts@:0 keep track of current agenda being displayed to show the pin icon for attachment
  showAgenda: any;
  hideAgenda: any;
  groupList: any = [];
  updateAgenda: Subscription;
  public comments: any[] = [];
  public newComment: string = '';
  public canPostComment: boolean = false; // Flag to check if user can post comments
  public editingCommentId: string | null = null; // Track which comment is being edited
  public editCommentText: string = ''; // Store the text being edited
  public currentUserId: string | null = null; // Store current logged-in user ID
  
  // Agenda Voting Properties
  public agendaVotes: any = {}; // Store votes by agendaID
  public votingLoading: boolean = false; // Track loading state
  public votingError: string | null = null; // Track errors
  public canVote: boolean = false; // Flag to check if user can vote (same as comments)
  
  constructor(
    public activeModal: NgbActiveModal,
    public meetingMasterService: MeetingMasterService,
    public elementRef: ElementRef,
    private viewSDKClient: ViewSDKClient,
    public sanitizer: DomSanitizer) {
    // Initialize user permissions early
    this.checkCommentPermission();
    
    this.meetingMasterService.Pagination.subscribe(id => {

      this.showAgenda = true;
      this.hideAgenda = false;
      this.currentAgendaOnDisplay=0;
      this.AgendaNumber = id;
      if (this.agendaObject) {
        this.count = this.getMaxIndex(this.agendaObject);
      }
    })
  }

  getButtonsDisabled(page) {
    console.log("00000000000000", page, this.count)
    if (page == this.count) {
      $('.next').hide();
      $('.lastAgenda').show();
      $('.back').show();
      $('.firstAgenda').hide();
    }
    if (page == -1) {
      $('.next').show();
      $('.lastAgenda').hide();
      $('.back').hide();
      $('.firstAgenda').show();
    }
    if (page >= 0 && page != this.count) {
      $('.back').show();
      $('.firstAgenda').hide();
      $('.next').show();
      $('.lastAgenda').hide();
    }

    if (page <= 1) {
      $('.next').show();
      $('.lastAgenda').hide();
      $('.back').hide();
      $('.firstAgenda').show();
    }

  }

  title = 'angularpdf';


  async ngOnChanges() {
    if (this.currentAgenda) {
      const { FinalUrl, page } = this.currentAgenda
      console.log("=========start", page, this.currentAgenda);
      this.currentAgendaOnDisplay=page-1;
      console.log("=========startAttach currentAgendaOnDisplay", this.currentAgendaOnDisplay);

      this.viewSDKClient.ready().then(() => {
        /* Invoke file preview */
        /* By default the embed mode will be Full Window */
        console.log("=========then", page, this.currentAgenda);
        this.viewSDKClient.previewFile('pdf-div', {},this.currentAgenda.FinalUrl,this.currentAgenda.filename);
      });


      this.AttachMent = FinalUrl;
      if (page != null && page >= 0)
        this.AgendaNumber = page;
      else
        this.AgendaNumber = 1;

      this.showAgenda = true;
      this.hideAgenda = false;
      this.count = this.getMaxIndex(this.agendaObject)
      this.getButtonsDisabled(page);
      if (_.size(this.agendaObject)) {
        this.agendaObject = _.sortBy(this.agendaObject, o => o.Agendaorder)
        this.agendaObject = (this.agendaObject).map(function (item) {
          var o = Object.assign({}, item);
          o.fileType = Array.isArray(item.AgendaGenerationPdf)
            ? item.AgendaGenerationPdf.map(function (subItem) {
                var oSub = Object.assign({}, subItem);
                oSub = (subItem.UploadFileName).slice(-3)
                return oSub;
              })
            : [];
          return o;
        });
        this.isAgendaObjectEmpty = false;
      } else {
        this.isAgendaObjectEmpty = true;
      }

      // Check if user can post comments (only BoardMember and KMP)
      this.checkCommentPermission();

      // Load comments for the current agenda
      this.loadComments();
      
      // Load voting data for the current agenda
      this.loadVotingData();
    }
  }

  public async updateComponent(fileID) {
    const response = await this.meetingMasterService.getAttendanceFileName(fileID)
    var url = environment.PSSFileurl + "/Document_Type/" + response.data.Filename + "#toolbar=0";
    var arr = url.split('https:'); // split string        
    var exc = arr[1];
    var url_exc = encodeURIComponent(exc);
    var newUrlPdf = url_exc + '/' + this.meetingObject._id + '/' + fileID + '/' + btoa(response.data.OriginalFileName)
    this.FinalUrl = location.protocol + "//" + location.host + "/#/pdfviewer/https:" + newUrlPdf;
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.FinalUrl);
    this.groupList.push({ 'name': this.FinalUrl.toString() });
    console.log(this.groupList)
  }

  initiateUploadAgendaPdf(data) {
    this.agendaPdfIsAvailable = data.AgendaGenerationPdf.IsPdfAvailable;
    this.agendaUplaodedPdfID = data.AgendaGenerationPdf.DocumentManagementID;
    this.agendaGenerationTitle = data.AgendaTitle;
    this.agendaGenerationNumber = data.AgendaNumber;
    this.agendaGenerationID = data._id;
    this.AgendaFile = data.AgendaGenerationPdf.map(element => {
      var o = Object.assign({}, element)
      o.FileType = (element.PdfName).substr(-3)
      return o;
    })

    $("#AgendaPdfUploadTitlePSPDF").html("Attachment For Agenda");
    $("#agendaPdfUploadDialogPSPFD").modal('toggle');
    $("#AgendaTitleOnPopup").html(this.agendaGenerationTitle);
    $('body').css('overflow', 'hidden');
    $('.modal').css('overflow', 'auto');
  }

  downloadDocumentFile(fileID, fileType) {
    if (fileType == 'PDF' || fileType == 'pdf') {
      $('#myModalForDocument').data('modal', null);
      console.log('agendadetail2')
      this.meetingMasterService.getAttendanceFileName(fileID).then(response => {
        var url = environment.PSSFileurl + "/Document_Type/" + response.data.Filename + "#toolbar=0";
        var arr = url.split('https:'); // split string        
        var exc = arr[1];
        var url_exc = encodeURIComponent(exc);
        var newUrlPdf = url_exc + '/' + this.meetingObject._id + '/' + fileID + '/' + btoa(response.data.OriginalFileName)
        this.AttachMent = location.protocol + "//" + location.host + "/#/pdfviewer/https:" + newUrlPdf;
        this.showAgenda = false;
        this.hideAgenda = true;
        $("#agendaPdfUploadDialogPSPFD").modal('hide');
        $('body').css('overflow', 'hidden');
        $('.modal').css('overflow', 'auto');

        this.viewSDKClient.ready().then(() => {
          /* Invoke file preview */
          /* By default the embed mode will be Full Window */
          console.error("=========downloadDocumentFile> then",  url);
          var filename = response.data.OriginalFileName ? response.data.OriginalFileName : "File";
          this.viewSDKClient.previewFile('pdf-div-attach', {},url,filename);
        });
      })
    } else {
      this.meetingMasterService.getAttendanceFile(fileID);
    }
  }

  closeModal() {
    $('body').css('overflow', 'hidden');
    $('.modal').css('overflow', 'auto');
  }

  showCurrent() {
    this.showAgenda = true;
    this.hideAgenda = false;
  }

  async showNext() {
    console.log("showNext", this.AgendaNumber, this.agendaObject, this.agendaObject?.length)
    this.showAgenda = true;
    this.hideAgenda = false;
    if(this.agendaObject && this.currentAgendaOnDisplay < this.agendaObject.length-1){//should now be increased if already on last agenda
      this.currentAgendaOnDisplay ++;
    }
    this.count = this.getMaxIndex(this.agendaObject);
    this.onEmitNext(1);
  }

  onEmitNext(increaseBy) {
    const targetNumber = String(parseInt(String(this.AgendaNumber), 10) + increaseBy);
    const agendaDetails = this.getPublishedAgendaList().filter(
      (ele) => String(ele.AgendaNumber) === targetNumber
    );
    if (!agendaDetails.length) {
      return;
    }
    const fileId = this.resolveAgendaDocumentId(agendaDetails[0]);
    if (!fileId) {
      this.onEmitNext(increaseBy + 1);
      return;
    }
    this.emitFileURL.emit({
      agendaId: fileId,
      page: parseInt(targetNumber, 10),
    });
  }

  getMaxIndex(array) {
    if (!array || !Array.isArray(array) || array.length === 0) {
      return 0;
    }
    let arr = array;
    let result = arr.sort(
      function (a, b) {
        return parseFloat(b['AgendaNumber']) - parseFloat(a['AgendaNumber']);
      }
    )[0]['AgendaNumber'];
    return result;
  }

  onEmitBack(increaseBy) {
    const targetNumber = String(parseInt(String(this.AgendaNumber), 10) - increaseBy);
    const agendaDetails = this.getPublishedAgendaList().filter(
      (ele) => String(ele.AgendaNumber) === targetNumber
    );
    if (!agendaDetails.length) {
      return;
    }
    const fileId = this.resolveAgendaDocumentId(agendaDetails[0]);
    if (!fileId) {
      this.onEmitBack(increaseBy + 1);
      return;
    }
    this.emitFileURL.emit({
      agendaId: fileId,
      page: parseInt(targetNumber, 10),
    });
  }

  private getPublishedAgendaList(): any[] {
    if (!Array.isArray(this.agendaObject)) {
      return [];
    }
    return this.agendaObject.filter((item) => item?.isPublished !== false);
  }

  private resolveAgendaDocumentId(agenda: any): string {
    if (!agenda) {
      return '';
    }
    if (
      agenda.AgendaConvertedDocxToPdf &&
      agenda.AgendaConvertedDocxToPdf.DocumentManagementID
    ) {
      return agenda.AgendaConvertedDocxToPdf.DocumentManagementID;
    }
    const generationPdf = agenda.AgendaGenerationPdf;
    if (Array.isArray(generationPdf) && generationPdf.length) {
      const withId = generationPdf.find((item) => item && item.DocumentManagementID);
      return withId ? withId.DocumentManagementID : '';
    }
    if (generationPdf && generationPdf.DocumentManagementID) {
      return generationPdf.DocumentManagementID;
    }
    return '';
  }

  async showBack() {
    this.showAgenda = true;
    if(this.currentAgendaOnDisplay>0){ //should now be reduced if already on first agenda
      this.currentAgendaOnDisplay --;
    }
    this.hideAgenda = false;
    this.count = this.getMaxIndex(this.agendaObject)
    this.onEmitBack(1);
  }

  addComment() {
    console.log("addComment", this.newComment)
    if (this.newComment && this.newComment.trim() !== '') {
      // Get the current agenda from agendaObject based on AgendaNumber
      const currentAgendaItem = this.getCurrentAgendaItem();
      if (!currentAgendaItem || !currentAgendaItem._id) {
        console.error('Cannot add comment: Agenda ID not found');
        alert('Cannot add comment. Please ensure an agenda is selected.');
        return;
      }

      const commentText = this.newComment.trim();
      const agendaId = currentAgendaItem._id;
      const meetingId = this.meetingObject ? this.meetingObject._id : null;

      // Save comment to backend
      this.meetingMasterService.addAgendaComment(agendaId, meetingId, commentText)
        .then((response: any) => {
          if (response && response.status === 0) {
            // Comment saved successfully, reload comments
            this.newComment = '';
            this.loadComments();
          } else {
            console.error('Error saving comment:', response);
            alert('Failed to save comment. Please try again.');
          }
        })
        .catch((error) => {
          console.error('Error saving comment:', error);
          alert('Failed to save comment. Please try again.');
        });
    }
  }

  loadComments() {
    // Get the current agenda from agendaObject based on AgendaNumber
    const currentAgendaItem = this.getCurrentAgendaItem();
    if (currentAgendaItem && currentAgendaItem._id) {
      this.meetingMasterService.getAgendaComments(currentAgendaItem._id)
        .then((response: any) => {
          if (response && response.status === 0 && response.data) {
            console.log('Raw comments response:', response.data);
            console.log('Current user ID before mapping:', this.currentUserId);
            console.log('canPostComment:', this.canPostComment);
            
            // Re-check permissions after loading comments to ensure currentUserId is set
            if (!this.currentUserId) {
              this.checkCommentPermission();
              console.log('Re-checked permissions, currentUserId:', this.currentUserId);
            }
            
            this.comments = response.data.map((comment: any) => {
              // Handle authorId - it might be an object with _id or a string
              let authorId = null;
              if (comment.authorId) {
                if (typeof comment.authorId === 'object' && comment.authorId._id) {
                  authorId = comment.authorId._id;
                } else if (typeof comment.authorId === 'string') {
                  authorId = comment.authorId;
                } else {
                  authorId = comment.authorId;
                }
              }
              
              const mappedComment = {
                text: comment.text,
                author: comment.author || 'Anonymous',
                date: comment.date ? new Date(comment.date) : new Date(),
                _id: comment._id,
                authorId: authorId // Store authorId to check ownership
              };
              
              console.log('Mapped comment:', {
                _id: mappedComment._id,
                authorId: mappedComment.authorId,
                authorIdType: typeof mappedComment.authorId,
                originalAuthorId: comment.authorId,
                originalAuthorIdType: typeof comment.authorId,
                currentUserId: this.currentUserId,
                currentUserIdType: typeof this.currentUserId,
                willMatch: String(this.currentUserId) === String(authorId)
              });
              
              return mappedComment;
            });
            
            console.log('All mapped comments:', this.comments);
          } else {
            this.comments = [];
          }
        })
        .catch((error) => {
          console.error('Error loading comments:', error);
          this.comments = [];
        });
    } else {
      this.comments = [];
    }
  }

  /**
   * Start editing a comment
   * Only the comment author can edit their own comment
   */
  startEditComment(comment: any): void {
    if (this.canPostComment && this.isCommentAuthor(comment)) {
      this.editingCommentId = comment._id;
      this.editCommentText = comment.text;
    } else {
      alert('You can only edit your own comments.');
    }
  }

  /**
   * Cancel editing a comment
   */
  cancelEditComment(): void {
    this.editingCommentId = null;
    this.editCommentText = '';
  }

  /**
   * Save the edited comment
   */
  saveEditComment(): void {
    if (!this.editingCommentId || !this.editCommentText || !this.editCommentText.trim()) {
      alert('Please enter a comment.');
      return;
    }

    this.meetingMasterService.updateAgendaComment(this.editingCommentId, this.editCommentText.trim())
      .then((response: any) => {
        if (response && response.status === 0) {
          // Comment updated successfully, reload comments
          this.cancelEditComment();
          this.loadComments();
        } else {
          console.error('Error updating comment:', response);
          // alert('Failed to update comment. Please try again.');
        }
      })
      .catch((error) => {
        console.error('Error updating comment:', error);
        // alert('Failed to update comment. Please try again.');
      });
  }

  /**
   * Delete a comment
   * Only the comment author can delete their own comment
   */
  deleteComment(commentId: string, comment: any): void {
    if (!this.canPostComment) {
      alert('You do not have permission to delete comments.');
      return;
    }

    // Check if current user is the author
    if (!this.isCommentAuthor(comment)) {
      alert('You can only delete your own comments.');
      return;
    }

    if (confirm('Are you sure you want to delete this comment?')) {
      this.meetingMasterService.deleteAgendaComment(commentId)
        .then((response: any) => {
          if (response && response.status === 0) {
            // Comment deleted successfully, reload comments
            this.loadComments();
          } else {
            console.error('Error deleting comment:', response);
            alert('Failed to delete comment. Please try again.');
          }
        })
        .catch((error) => {
          console.error('Error deleting comment:', error);
          alert('Failed to delete comment. Please try again.');
        });
    }
  }

  /**
   * Get the current agenda item from agendaObject based on AgendaNumber
   */
  getCurrentAgendaItem(): any {
    if (!this.agendaObject || !Array.isArray(this.agendaObject) || !this.AgendaNumber) {
      console.log('getCurrentAgendaItem: Missing data', {
        agendaObject: this.agendaObject,
        AgendaNumber: this.AgendaNumber
      });
      return null;
    }
    
    const agendaItem = this.agendaObject.find(item => 
      item.AgendaNumber === this.AgendaNumber.toString() || 
      item.AgendaNumber === this.AgendaNumber
    );
    
    console.log('getCurrentAgendaItem: Found agenda', {
      AgendaNumber: this.AgendaNumber,
      agendaItem: agendaItem,
      agendaId: agendaItem ? agendaItem._id : null
    });
    
    return agendaItem || null;
  }

  isCommentDisabled(): boolean {
    if (!this.newComment) {
      return true;
    }
    const trimmed = this.newComment.trim();
    return !trimmed || trimmed.length === 0;
  }

  /**
   * Check if the current user has permission to post comments
   * Only BoardMember and KMP can post comments
   */
  checkCommentPermission(): void {
    try {
      const userInfo = JSON.parse(localStorage.getItem('user'));
      if (userInfo) {
        // Store current user ID
        this.currentUserId = userInfo._id || userInfo.id || null;
        
        if (userInfo.TypeOfUser) {
          const userType = userInfo.TypeOfUser;
          // Only BoardMember and KMP can post comments
          this.canPostComment = userType === 'BoardMember' || userType === 'KMP';
          // Same permission for voting
          this.canVote = userType === 'BoardMember' || userType === 'KMP';
        } else {
          this.canPostComment = false;
          this.canVote = false;
        }
      } else {
        this.canPostComment = false;
        this.canVote = false;
        this.currentUserId = null;
      }
    } catch (error) {
      console.error('Error checking comment permission:', error);
      this.canPostComment = false;
      this.canVote = false;
      this.currentUserId = null;
    }
  }

  /**
   * Check if the current user is the author of a comment
   * Only the comment author can edit or delete their own comment
   */
  isCommentAuthor(comment: any): boolean {
    // First check if we have the basic requirements
    if (!this.currentUserId) {
      console.warn('isCommentAuthor: currentUserId is not set', {
        currentUserId: this.currentUserId
      });
      return false;
    }
    
    if (!comment) {
      console.warn('isCommentAuthor: comment is null or undefined');
      return false;
    }
    
    // Check if authorId exists in comment
    if (!comment.authorId) {
      console.warn('isCommentAuthor: comment.authorId is missing', {
        comment: comment,
        commentKeys: Object.keys(comment || {})
      });
      return false;
    }
    
    // Normalize both IDs to strings for comparison
    let currentUserIdStr = '';
    let authorIdStr = '';
    
    try {
      currentUserIdStr = String(this.currentUserId).trim();
      authorIdStr = String(comment.authorId).trim();
    } catch (e) {
      console.error('Error converting IDs to string:', e);
      return false;
    }
    
    // Compare current user ID with comment author ID
    const isAuthor = currentUserIdStr === authorIdStr;
    
    // Log for debugging
    // if (!isAuthor) {
    //   console.log('isCommentAuthor: IDs do not match', {
    //     currentUserId: currentUserIdStr,
    //     commentAuthorId: authorIdStr,
    //     currentUserIdType: typeof this.currentUserId,
    //     authorIdType: typeof comment.authorId,
    //     comment: comment
    //   });
    // } else {
    //   console.log('isCommentAuthor: IDs match - user is author', {
    //     currentUserId: currentUserIdStr,
    //     commentAuthorId: authorIdStr
    //   });
    // }
    
    return isAuthor;
  }

  // ==================== AGENDA VOTING METHODS ====================

  /**
   * Load voting data for the current agenda
   */
  loadVotingData(): void {
    const currentAgendaItem = this.getCurrentAgendaItem();
    if (!currentAgendaItem || !currentAgendaItem._id || !this.meetingObject) {
      this.agendaVotes = {};
      return;
    }

    this.votingLoading = true;
    this.votingError = null;

    this.meetingMasterService.getAgendaVoteSummary(this.meetingObject._id, currentAgendaItem._id)
      .then((response: any) => {
        // PSS uses numeric 0 for success; some paths stringify it — use == 0
        if (response != null && response.status == 0) {
          this.agendaVotes = response.data;
        } else {
          this.votingError = response.message || 'Failed to load votes';
        }
        this.votingLoading = false;
      })
      .catch(error => {
        console.error('Error loading agenda vote:', error);
        this.votingError = 'Error loading votes';
        this.votingLoading = false;
      });
  }

  /**
   * Submit a vote for the current agenda
   */
  submitVote(voteType: 'APPROVE' | 'REJECT'): void {
    if (!this.canVote) {
      alert('Only Board Members and KMP can vote on agendas.');
      return;
    }

    const currentAgendaItem = this.getCurrentAgendaItem();
    if (!currentAgendaItem || !currentAgendaItem._id || !this.meetingObject) {
      alert('Cannot submit vote. Please ensure an agenda is selected.');
      return;
    }

    const user = JSON.parse(localStorage.getItem('user'));
    const companyDetails = JSON.parse(localStorage.getItem('companyDetails'));
    
    const voteData = {
      MeetingID: this.meetingObject._id,
      AgendaID: currentAgendaItem._id,
      AgendaNumber: currentAgendaItem.AgendaNumber,
      AgendaTitle: currentAgendaItem.AgendaTitle,
      VoteType: voteType,
      UserID: user._id,
      UserName: user.FirstName + ' ' + user.LastName,
      UserEmail: user.EmailId || '',
      CompanyID: companyDetails?.companyId || user.companyId
    };

    this.votingLoading = true;
    this.votingError = null;

    this.meetingMasterService.submitAgendaVote(voteData)
      .then((response: any) => {
        if (response != null && response.status == 0) {
          // Reload vote summary to get updated counts
          this.loadVotingData();
        } else {
          this.votingError = response.message || 'Failed to submit vote';
          this.votingLoading = false;
        }
      })
      .catch(error => {
        console.error('Error submitting vote:', error);
        this.votingError = error.message || 'Error submitting vote';
        this.votingLoading = false;
      });
  }

  /**
   * Retract/delete user's vote
   */
  retractVote(): void {
    if (!this.canVote) {
      return;
    }

    const currentAgendaItem = this.getCurrentAgendaItem();
    if (!currentAgendaItem || !currentAgendaItem._id || !this.meetingObject) {
      return;
    }

    if (!confirm('Are you sure you want to retract your vote?')) {
      return;
    }

    this.votingLoading = true;
    this.votingError = null;

    this.meetingMasterService.retractAgendaVote(this.meetingObject._id, currentAgendaItem._id)
      .then((response: any) => {
        if (response != null && response.status == 0) {
          // Reload vote summary to get updated counts
          this.loadVotingData();
        } else {
          this.votingError = response.message || 'Failed to retract vote';
          this.votingLoading = false;
        }
      })
      .catch(error => {
        console.error('Error retracting vote:', error);
        this.votingError = error.message || 'Error retracting vote';
        this.votingLoading = false;
      });
  }

  /**
   * Get current user's vote
   */
  getUserVote(): any {
    return this.agendaVotes?.userVote || null;
  }

  /**
   * Check if user has voted
   */
  hasUserVoted(): boolean {
    return !!this.agendaVotes?.userVote;
  }

  /**
   * Get vote counts
   */
  getVoteCounts(): any {
    return {
      approveCount: this.agendaVotes?.approveCount || 0,
      rejectCount: this.agendaVotes?.rejectCount || 0,
      totalVotes: this.agendaVotes?.totalVotes || 0
    };
  }
}